module.exports = __webpack_public_path__ + "img/24.5c5808c2.jpg";